<form [formGroup]="form" id="wrapper" #wrapper>
  <div formArrayName="{{ formularGroupDataKey }}">
    @for (
      kategorie of wartungenCtlArray.controls;
      track kategorie;
      let i = $index
    ) {
      <div>
        <cst-card>
          <ng-template cstCardTitle>
            <span>{{ getKategorieByIndex(i)["Label"] }}</span>
          </ng-template>
          <ng-template cstCardContent>
            <div [formArrayName]="i" class="wartung-wrapper">
              @for (
                ctl of getKategorieCtlArray(i).controls;
                track ctl;
                let j = $index
              ) {
                <div class="wartung-item-wrapper">
                  <mat-label>{{ getElementByIndex(i, j)["Label"] }}</mat-label>
                  <mat-chip-listbox
                    [formControl]="ctl"
                    ariaOrientation="horizontal"
                  >
                    @for (opt of wartungOptions; track opt) {
                      <mat-chip-option
                        [selected]="opt.label"
                        [value]="opt.value"
                        selectable
                        class="wartung-chip"
                        [style.--wartung-bg]="opt.bgColor"
                        [style.--wartung-fg]="opt.fontColor"
                      >
                        {{ opt.char }} {{ opt.label }}
                      </mat-chip-option>
                    }
                  </mat-chip-listbox>
                </div>
              }
            </div>
            @if (hasBerichte(getKategorieByIndex(i))) {
              @for (
                bericht of getKategorieBerichte(getKategorieByIndex(i));
                track bericht;
                let j = $index
              ) {
                <div class="bericht-wrapper">
                  <bericht-item-text
                    [data]="bericht"
                    [ctl]="getBerichtCtl(i, 'bericht-' + j)"
                    [ctlName]="'bericht-' + j"
                    [parentGroup]="getBerichtCtlGroup(i)"
                    [areaHeight]="4"
                  ></bericht-item-text>
                </div>
              }
            }
          </ng-template>
        </cst-card>
      </div>
    }
  </div>
</form>
